type GetTextsArgs = {
  isUpdating?: boolean;
  canOnlyReduce: boolean;
};

export const getTexts = ({ isUpdating, canOnlyReduce }: GetTextsArgs) => {
  let submitButtonText = 'Submit auction request';
  let title = 'Set your reserve price';

  if (canOnlyReduce) {
    title = 'Reduce your reserve price';
    submitButtonText = 'Reduce your reserve';
  } else if (isUpdating) {
    title = 'Update your reserve';
    submitButtonText = 'Update reserve';
  }

  return { submitButtonText, title };
};
